import React from 'react'

import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'
import { Image, Flex, Text } from '@chatterbug/aaron'

import catBee from './assets/catbee@2x.png'

const logoText = 'chatterbug'

const LogoutLogo = () => {
  return (
    <Flex
      pt="2x"
      as="a"
      alignItems="flex-end"
      href={routes.logout()}
      sx={{
        ':hover': {
          textDecoration: 'none',
        },
      }}
      aria-label={t('Logout and return to homepage')}
    >
      <Image height="32px" mr="1x" src={catBee} alt="" />
      <Text color="white" fontSize="md">
        {logoText}
      </Text>
    </Flex>
  )
}

export default LogoutLogo
